<div class="main-container" data-cy="ar-insurance-claims">

  <div class="main-header" data-cy="ar-insurance-claims-header">
    Insurance Claims
  </div>


  <div class="transaction-list-container" data-cy="ar-insurance-claims-list-container">

    <div *ngIf="isLoading" data-cy="ar-insurance-claims-loading">
      <mat-progress-bar mode="indeterminate" data-cy="ar-insurance-claims-progress-bar"></mat-progress-bar>
    </div>

    <div *ngIf="!isLoading" class="transaction-list" data-cy="ar-insurance-claims-list">

      <div class="transaction-item mat-elevation-z2" *ngFor="let transactionItem of dataTransactionItems" data-cy="ar-insurance-claims-item">

        <div class="flex-item item-procedure-detail-container" data-cy="ar-insurance-claims-procedure-container">

          <div class="detail-item" data-cy="ar-insurance-claims-procedure-detail">

            <div class="sub-header" data-cy="ar-insurance-claims-procedure-header">
              Procedure
            </div>

            <div class="sub-content" data-cy="ar-insurance-claims-procedure-name">
              {{ transactionItem.dataPatientCaseWorkItem.cfgCaseProcedure.ProcedureName }}
            </div>

          </div>

          <div class="detail-item" data-cy="ar-insurance-claims-code-detail">
            <div class="sub-header" data-cy="ar-insurance-claims-code-header">
              Code
            </div>

            <div class="sub-content" data-cy="ar-insurance-claims-code-value">
              {{ transactionItem.Code }}
            </div>
          </div>

        </div>

        <div class="flex-item item-cost-detail-container" data-cy="ar-insurance-claims-cost-container">

          <div class="detail-item" data-cy="ar-insurance-claims-fee-detail">
            <div class="sub-header" data-cy="ar-insurance-claims-fee-header">
              Doctor Fee
            </div>

            <div class="sub-content" data-cy="ar-insurance-claims-fee-value">
              {{ transactionItem.Price | currency }}
            </div>

          </div>

          <div class="detail-item" data-cy="ar-insurance-claims-coverage-detail">
            <div class="sub-header" data-cy="ar-insurance-claims-coverage-header">
              Insurance Coverage
            </div>

            <div class="sub-content" data-cy="ar-insurance-claims-coverage-value">

              <div *ngIf="transactionItem.enumFeeCoverageCalcTypeId === this.enumCoverageTypeAmount" data-cy="ar-insurance-claims-coverage-amount">
                {{ transactionItem.CoverageAmount | currency }}
              </div>

              <div *ngIf="transactionItem.enumFeeCoverageCalcTypeId !== this.enumCoverageTypeAmount" data-cy="ar-insurance-claims-coverage-percent">
                {{ (transactionItem.CoveragePCT / 100) | percent }}
              </div>

            </div>
           
          </div>

        </div>

        <div class="flex-item item-cost-detail-container" data-cy="ar-insurance-claims-billable-container">

          <div class="detail-item" data-cy="ar-insurance-claims-billable-detail">
            <div class="sub-header" data-cy="ar-insurance-claims-billable-header">
              Billable to insurance
            </div>

            <div class="sub-content" data-cy="ar-insurance-claims-billable-value">
              {{ calculateCost(transactionItem, 'insurance') | currency }}
            </div>

          </div>

          <div class="detail-item" data-cy="ar-insurance-claims-status-detail">
            <div class="sub-header" data-cy="ar-insurance-claims-status-header">
              Status
            </div>

            <div class="sub-content" data-cy="ar-insurance-claims-status-value">
              {{ getEnumStatus(transactionItem) }}
            </div>

          </div>

        </div>

      </div>

    </div>


  </div>

</div>
